<template>
  <el-dialog :title="dialogTitle" :visible.sync="contentInfoVisible" append-to-body>
    <el-form
      ref="contentForm"
      label-width="100px"
    >
      <el-form-item label="工作内容" class="contentInfoText">
        {{contentInfo.tips}}
      </el-form-item>
      <el-form-item label="图片" class="contentInfoImg" v-if="contentInfo.imgPaths.length>0">
        <div class="cAudio" v-for="(imgPath,index) in contentInfo.imgPaths" :key="index">
          <img preview="1" :src="imgPath|getBaseImgUrl">
        </div>
      </el-form-item>
      <el-form-item label="视频" class="contentInfoVideo" v-if="contentInfo.videoPaths.length>0">
        <div class="cAudio"  v-for="(videoPath,index) in contentInfo.videoPaths" :key="index">
          <video style="float:left;margin-right:1%;"
           width="125px" height="125px" :src="videoPath|getBaseImgUrl" controls="controls" type="video/mp4">您的浏览器不支持视频播放</video>
        </div>
      </el-form-item>
    </el-form>
    <span slot="footer" class="dialog-footer" style="text-align:center;">
      <el-button @click="close">关闭</el-button>
    </span>
  </el-dialog>
</template>

<script>
import { apiLink, getImgLink } from "@/config/env";
export default {
  name: "contentInfo",
  data() {
    return {
      contentInfoVisible: false,
      dialogTitle: "工作内容详情",
      contentInfo: {
        tips: "",
        imgPaths: [],
        imgCount:0,
        videoPaths: [],
        videoCount:0
      }
    };
  },
  created() {

  },
  filters: {
    getBaseImgUrl: function(uri) {
      if (uri) {
        return getImgLink(uri);
      } else {
        return "";
      }
    },
  },
  methods: {
    setData(data) {
      let that =this
      that.contentInfoVisible = true;
      that.cleanForm();
      if (data) {
        that.contentInfo.tips = data.tips;
        if(data.imgPaths){
          data.imgPaths.split(",").forEach(path => {
            that.contentInfo.imgPaths.push(path);
          })
        }
        if(data.videoPaths){
          data.videoPaths.split(",").forEach(path => {
            that.contentInfo.videoPaths.push(path);
          })
        }
      }
      that.$previewRefresh();
    },
    close() {
      this.contentInfoVisible = false;
      this.cleanForm();
    },
    cleanForm() {
      this.contentInfo = {
        tips: "",
        imgPaths: [],
        imgCount:0,
        videoPaths: [],
        videoCount:0
      };
    }
  }
};
</script>
<style lang="scss" scoped="scoped">
.pswp{
  z-index: 9999 !important;
}
.el-form-item{
  img{
    margin-right: 15px;
  }
}
.el-form-item__label{
  font-weight: bold;
}
</style>
